export const WALMART = 'walmart';

export const WALMART_API_TYPES = {
    UPLOAD_CREATIVE_IMAGE: 'upload_creative_image',
    CREATE_THE_CREATIVES: 'create_the_creatives',
    CREATE_FOLDER: 'create_folder',
    LIST_ALL_THE_FOLDERS: 'list_all_the_folders',
    REQUEST_CREATIVE_PREVIEW: 'request_creative_preview',
    PREVIEW_STATUS: 'preview_status',
    RETRIEVE_PREVIEW_URL: 'retrieve_preview_url',
    RETRIEVE_CREATIVE_PREVIEW_FOR_EACH_ADUNIT: 'retrieve_creative_preview_for_each_adUnit',
    UPDATE_CREATIVE: 'update_creative',
    UPDATE_CREATIVE_V2: 'update_creative_v2',
    UPDATE_THE_FOLDER: 'update_the_folder',
    UPLOAD_MEDIA: 'media_upload_media',
    RETRIEVE_SNAPSHOTS: 'report_retrieve_snapshots',
};

export const adUnits = {
    BRANDBOX_DESKTOP: 'brandboxDesktop',
    BRANDBOX_APP: 'brandboxApp',
    GALLERY_DESKTOP: 'galleryDesktop',
    GALLERY_APP: 'galleryApp',
    MARQUEE_DESKTOP: 'marqueeDesktop',
    // MARQUEE_TABLET: 'marqueeTablet',
    MARQUEE_APP: 'marqueeApp',
    SKYLINE_DESKTOP: 'skylineDesktop',
    // SKYLINE_APP: 'skylineApp',
    LOGO: 'logo',
    SKYLINE_DESKTOP_V2: 'skylineDesktopV2',
    // SKYLINE_APP_V2: 'skylineAppV2',
    SKYLINE_DESKTOP_V3: 'skylineDesktopV3',
    SKYLINE_APP_V3: 'skylineAppV3',
    TILE_DESKTOP: 'tileDesktop',
    TILE_APP: 'tileApp',
};

export const requiredUnitTypes = {
    [adUnits.GALLERY_DESKTOP]: 'Gallery Desktop',
    [adUnits.GALLERY_APP]: 'Gallery App',
    [adUnits.BRANDBOX_DESKTOP]: 'Brandbox Desktop',
    [adUnits.BRANDBOX_APP]: 'Brandbox App',
    [adUnits.MARQUEE_DESKTOP]: 'Marquee Desktop',
    // [adUnits.MARQUEE_TABLET]: 'Marquee Tablet',
    [adUnits.MARQUEE_APP]: 'Marquee App',
    [adUnits.SKYLINE_DESKTOP]: 'Skyline Desktop',
    [adUnits.LOGO]: 'Logo',
    [adUnits.SKYLINE_DESKTOP_V2]: 'Skyline Desktop V2',
    // [adUnits.SKYLINE_APP_V2]: 'Skyline App V2',
    [adUnits.SKYLINE_DESKTOP_V3]: 'Skyline Desktop V3',
    [adUnits.SKYLINE_APP_V3]: 'Skyline App V3',
    [adUnits.TILE_DESKTOP]: 'Tile Desktop',
    [adUnits.TILE_APP]: 'Tile App',
};

export const adUnitsDimensions = {
    '1040x246': adUnits.BRANDBOX_DESKTOP,
    '792x260': adUnits.BRANDBOX_APP,
    '788x444': adUnits.GALLERY_DESKTOP,
    '432x242': adUnits.GALLERY_APP,
    '1510x356': adUnits.MARQUEE_DESKTOP,
    // '1088x356': adUnits.MARQUEE_TABLET,
    '508x260': adUnits.MARQUEE_APP,
    '1232x104': adUnits.SKYLINE_DESKTOP,
    // '508x260': SKYLINE_APP,
    '150x150': adUnits.LOGO,
    '1080x124': adUnits.SKYLINE_DESKTOP_V2,
    // '200x100': adUnits.SKYLINE_APP_V2,
    '242x124': adUnits.SKYLINE_DESKTOP_V3,
    '242x120': adUnits.SKYLINE_APP_V3,
    '580x870': adUnits.TILE_DESKTOP,
    '580x870m': adUnits.TILE_APP,
    '200x260': '200x260',
    '112x112': '112x112',
    '220x100': '220x100',
    '120x72': '120x72',
    '154x92': '154x92',
    '324x112': '324x112',
};

export const adUnitTypes = {
    [adUnits.GALLERY_DESKTOP]: 'Gallery Desktop',
    [adUnits.GALLERY_APP]: 'Gallery App',
    [adUnits.BRANDBOX_DESKTOP]: 'Brandbox Desktop',
    [adUnits.BRANDBOX_APP]: 'Brandbox App',
    [adUnits.MARQUEE_DESKTOP]: 'Marquee Desktop',
    'marqueeTablet': 'Marquee Tablet',
    [adUnits.MARQUEE_APP]: 'Marquee App',
    [adUnits.SKYLINE_DESKTOP]: 'Skyline Desktop',
    'skylineApp': 'Skyline App',
    [adUnits.SKYLINE_DESKTOP_V2]: 'Skyline Desktop V2',
    'skylineAppV2': 'Skyline App V2',
    [adUnits.SKYLINE_DESKTOP_V3]: 'Skyline Desktop V3',
    [adUnits.SKYLINE_APP_V3]: 'Skyline App V3',
    [adUnits.TILE_DESKTOP]: 'Tile Desktop',
    [adUnits.TILE_APP]: 'Tile App',
};

export const ASSET_TYPES = {
    LOGO: 'logo',
    LIFESTYLE: 'lifestyle',
}

export const NON_DEFAULT_LOGO_DIMENSIONS = ['200x260', '112x112', '220x100', '120x72', '154x92', '324x112'];

export const CREATIVE_SETTINGS = 'walmart_creative_settings';
